import type { StateCreator } from "zustand";

export interface IntentSliceState {
  intentUrl: string | undefined;
}

interface IntentSliceActions {
  setIntentUrl: (
    nextIntentUrl:
      | IntentSliceState["intentUrl"]
      | ((currentIntentUrl: IntentSliceState["intentUrl"]) => IntentSliceState["intentUrl"])
  ) => void;
}

export type IntentSlice = IntentSliceState & IntentSliceActions;

export const createIntentSlice: StateCreator<
  IntentSlice,
  [["zustand/devtools", never]],
  [],
  IntentSlice
> = (set) => ({
  intentUrl: undefined,
  setIntentUrl: (nextIntentUrl) =>
    set((state) => ({
      intentUrl:
        typeof nextIntentUrl === "function" ? nextIntentUrl(state.intentUrl) : nextIntentUrl,
    })),
});
